import type { ChatMessageInput } from "@src/gql/graphql";
import { getAssistantMessageCopyText } from "./agent-chat-message-text";
import {
	agentChatMessageSchema,
	wireChatRoleSchema,
} from "./agent-chat-schemas";
import type { AgentChatMessage } from "./types";

export function toAgentChatMessage(node: {
	id: string;
	role: string;
	content?: string | null;
	rawJson?: string | null;
	createdAt: string | number;
}): AgentChatMessage {
	if (node.rawJson) {
		try {
			const parsed = agentChatMessageSchema.safeParse(JSON.parse(node.rawJson));
			if (parsed.success) {
				return parsed.data;
			}
		} catch {
			// Fallback below
		}
	}

	const createdAt =
		typeof node.createdAt === "number"
			? node.createdAt
			: new Date(node.createdAt).getTime();
	const createdAtMs = Number.isNaN(createdAt) ? Date.now() : createdAt;
	const role = wireChatRoleSchema.safeParse(node.role);
	if (role.success && role.data === "user") {
		return {
			id: node.id,
			role: "user",
			content: node.content ?? "",
			createdAt: createdAtMs,
		};
	}

	return {
		id: node.id,
		role: "assistant",
		parts: [{ type: "text", text: node.content ?? "" }],
		createdAt: createdAtMs,
	};
}

export function toSaveChatMessageInput(
	_chatId: string,
	message: AgentChatMessage,
	model?: string | null,
): ChatMessageInput {
	const content =
		message.role === "user"
			? message.content
			: getAssistantMessageCopyText(message);

	return {
		messageId: message.id,
		role: message.role,
		type: message.role === "assistant" ? "ai_response" : "user_message",
		content,
		model: model ?? undefined,
		rawJson: JSON.stringify(message),
	};
}
